<div class="card" *ngIf="!skeleton" [routerLink]="['/events']" [queryParams]="{category: name}">
    <img [src]="image">
    <h6 class="m-0">{{ name }}</h6>
</div>

<ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '60px', 'border-radius': '10px' }" *ngIf="skeleton"></ngx-skeleton-loader>
